<template>
  <div>
    <header class="site-header">
      <div class="container">
        <div class="row align-items-center">
          <div class="col-lg-7 d-flex">
            <a v-on:click="this.$router.push('home')" href="javascript:void(0)">
              <img
                src="/static/images/logo-horizontal.svg"
                width="200"
                class="me-5"
                alt=""
              />
            </a>
            <div
              class="d-flex align-items-center gap-2 text-truncate"
              v-if="workshop_id && pageType != 'ONBOARDING'"
            >
              <div>
                <img src="/static/images/icon-location.svg" width="40" alt="" />
              </div>
              <div class="text-truncate">
                <h4 class="mb-0 font-14">
                  {{ meData?.workshop?.workshop_name }}
                </h4>
                <p class="mb-0 font-12 text-secondary text-truncate">
                  {{ meData?.workshop?.address_line_1 }}, {{ meData?.workshop?.address_line_2 }}
                </p>
              </div>
              <a
                v-on:click="this.$router.push('/reward-history')"
                href="javascript:void(0)"
                class="reward"
              >
                <img src="/static/images/icon-reward.svg" width="30" alt="" />
                <span>{{ meData?.workshop?.rewards }}</span>
              </a>
            </div>
          </div>
          <div
            class="col-lg-5 d-flex justify-content-end gap-5 align-items-center"
          >
            <template v-if="workshop_id && pageType != 'ONBOARDING'">
              <nav class="navbar">
                <ul class="navbar-nav ms-auto mb-2 mb-lg-0">
                  <li class="nav-item" v-on:click="this.$router.push('/home')">
                    <a
                      class="nav-link"
                      :class="{ 'bold-black': $route.path === '/home' }"
                      href="javascript:void(0)"
                      >Home</a
                    >
                  </li>
                  <li
                    class="nav-item"
                    v-on:click="this.$router.push('/orders')"
                  >
                    <a
                      class="nav-link"
                      :class="{ 'bold-black': $route.path === '/orders' }"
                      href="javascript:void(0)"
                      >Orders</a
                    >
                  </li>
                  <li
                    class="nav-item"
                    v-on:click="this.$router.push('/conversation')"
                  >
                    <a
                      class="nav-link"
                      :class="{ 'bold-black': $route.path === '/conversation' }"
                      href="javascript:void(0)"
                      >Chats</a
                    >
                  </li>
                  <li
                    class="nav-item"
                    v-on:click="this.$router.push('/account')"
                  >
                    <a
                      class="nav-link"
                      :class="{ 'bold-black': $route.path === '/account' }"
                      href="javascript:void(0)"
                      >Account</a
                    >
                  </li>
                </ul>
              </nav>
            </template>
            <template v-else>
              <a href="javascript:void(0)" v-on:click="handleLogout">
                <svg
                  width="20px"
                  height="20px"
                  viewBox="0 0 20 20"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fill="#004852"
                    d="M10.2392344,0 C13.3845587,0 16.2966635,1.39466883 18.2279685,3.74426305 C18.4595621,4.02601608 18.4134356,4.43777922 18.124942,4.66396176 C17.8364485,4.89014431 17.4148346,4.84509553 17.183241,4.5633425 C15.5035716,2.51988396 12.9739849,1.30841121 10.2392344,1.30841121 C5.32416443,1.30841121 1.33971292,5.19976806 1.33971292,10 C1.33971292,14.8002319 5.32416443,18.6915888 10.2392344,18.6915888 C13.0144533,18.6915888 15.5774656,17.443711 17.2546848,15.3485857 C17.4825482,15.0639465 17.9035339,15.0136047 18.1949827,15.2361442 C18.4864315,15.4586837 18.5379776,15.8698333 18.3101142,16.1544725 C16.3816305,18.5634688 13.4311435,20 10.2392344,20 C4.58426141,20 8.8817842e-14,15.5228475 8.8817842e-14,10 C8.8817842e-14,4.4771525 4.58426141,0 10.2392344,0 Z M17.0978642,7.15999289 L19.804493,9.86662172 C20.0660882,10.1282169 20.071043,10.5473918 19.8155599,10.802875 L17.17217,13.4462648 C16.9166868,13.701748 16.497512,13.6967932 16.2359168,13.435198 C15.9743215,13.1736028 15.9693667,12.7544279 16.2248499,12.4989447 L17.7715361,10.9515085 L7.46239261,10.9518011 C7.0924411,10.9518011 6.79253615,10.6589032 6.79253615,10.2975954 C6.79253615,9.93628766 7.0924411,9.64338984 7.46239261,9.64338984 L17.7305361,9.64250854 L16.1726778,8.08517933 C15.9110825,7.82358411 15.9061278,7.40440925 16.1616109,7.14892607 C16.4170941,6.89344289 16.836269,6.89839767 17.0978642,7.15999289 Z"
                  />
                </svg>
              </a>
            </template>
          </div>
        </div>
      </div>
    </header>
  </div>
</template>
<script>
export default {
  name: "HeaderTop",

  components: {},

  data() {
    return {
      meData: "",
      token: localStorage.getItem("access_token"),
    };
  },

  computed: {
    pageType() {
      return this.$store.getters.getPageType;
    },
    workshop_id() {
      return this.$store.getters.getWorkshopId;
    },
  },

  mounted() {
    if (localStorage.getItem("access_token")) {
      this.getMeCall();
      localStorage.setItem("is_cost_skip", "N");
      localStorage.setItem("is_photo_skip", "N");
    }
  },
  methods: {
    getMeCall() {
      this.$api
        .getAPI({
          _action: "me",
        })
        .then((res) => {
          this.meData = res.result;
          var next_url = localStorage.getItem("next_url") ?? "";
          localStorage.setItem("userDetail", JSON.stringify(res.result));
          localStorage.setItem("workshop_id", res.result.workshop_id ?? "");
          if (next_url) {
            this.$router.push(next_url);
          } else {
            if (res.result && res.result.workshop_count == 0) {
              localStorage.setItem("page_type", "ONBOARDING");
              this.$store.commit("setPageType", "ONBOARDING");
              this.$router.push("/personal-details");
              // this.$router.push("/onboard");
            }
          }
        })
        .catch(() => {});
    },
    handleLogout() {
      this.$swal({
        title: "Are you sure?",
        text: "You want to logout ",
        icon: "Warning",
        showCancelButton: true,
        confirmButtonText: "Yes,",
        cancelButtonText: "No, cancel!",
      }).then((result) => {
        if (result.isConfirmed) {
          if (this.$refs.errorComponent) {
            this.$refs.errorComponent.showLoader(true);
          }
          this.$api
            .getAPI({
              _action: "logout",
            })
            .then(() => {
              if (this.$refs.errorComponent) {
                this.$refs.errorComponent.showLoader(false);
              }
              localStorage.clear();
              this.$api.clearCache();
              this.$store.commit("setPageType", "");
              this.$store.commit("setAccessToken", "");
              this.$store.commit("setWorkshopId", "");
              this.$router.push("/login");
            })
            .catch(() => {
              if (this.$refs.errorComponent) {
                this.$refs.errorComponent.showLoader(false);
              }
            });
        }
      });
    },
  },
};
</script>
<style>
.bold-black {
  font-weight: bold;
  color: black;
}
</style>
